module.exports = __webpack_public_path__ + "img/DE02770.91fda4b2.png";